document.querySelectorAll('.show_password').forEach(function(toggleBtn) {
  toggleBtn.addEventListener('click', function() {
    const passwordField = this.parentElement.querySelector('#CustomerPassword, #customer_password, #RegisterForm-password');
    if (passwordField) {
      const fieldType = passwordField.getAttribute('type');
      passwordField.setAttribute('type', fieldType === 'password' ? 'text' : 'password');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Delay scroll slightly to allow page layout to settle
  setTimeout(function () {
    if (window.location.hash === '#recover') {
      window.scrollTo({ top: 100, behavior: 'smooth' });
    }
  }, 100); // 100ms delay to allow rendering
});



function MatchHeight() {

    $('.forget-password,.cancel').click(function(){
      $("html, body").animate({ scrollTop: 100 }, "slow");
    });
  
     jQuery('body .blog-layout-default .blog-block-item .blog-title').matchHeight();
     jQuery('.cnt-clm6 h3.article-card__title').matchHeight();
     jQuery('.cst-index .bg-policies-block .policies-content').matchHeight();
    
     
     
}


$(document).ready(function() {

  MatchHeight(); 

});



$(document).on('click', '#bss-b2b-net-term-button', function () {
    $('body').addClass('apps-popup-open');
});

// Remove class
$(document).on('click', '.b2b-nt-close-btn', function () {
    $('body').removeClass('apps-popup-open');
});